import { render, staticRenderFns } from "./FinalizacaoSimples.vue?vue&type=template&id=0d5dcc1d&scoped=true&"
import script from "./FinalizacaoSimples.vue?vue&type=script&setup=true&lang=js&"
export * from "./FinalizacaoSimples.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5dcc1d",
  null
  
)

export default component.exports